import React from 'react';

const Success = () => (
  <div className="c-handoff-bar c-handoff-bar_success">
    <span className="u-fontsize-tiny u-type--bold u-co-white">
      Successfully handed off.
    </span>
  </div>
);

export default Success;
